<template>
  <VueBaseDialog ref="VueBaseDialog" :dialogConfig="dialogConfig">
    <!-- 文档预览 -->
    <div class="pdf-view" v-if="dialogConfig.type == 4">
      <iframe id="pdfPreload"  :src="dialogConfig.path" style="width: 1200px;height: 675px;" scrolling="no" frameborder="0" allowfullscreen="allowfullscreen"></iframe>
    </div>
    
    <!-- 图片预览 -->
    <!-- <div class="img-view" v-else-if="dialogConfig.type == 1">
      <img id="imgPreview" :src="dialogConfig.path">
    </div> -->
    <!-- 音频预览 -->
    <!-- <template v-else>
      <div class="audio-adorn">
        <div class="adorn-label"></div>
        <div class="adorn-line-1"></div>
        <div class="adorn-line-2"></div>
      </div>
      <audio class="audio-view" ref="audio" controls :src="dialogConfig.path"></audio>
    </template> -->
  </VueBaseDialog>
</template>
<script>
import VueBaseDialog from './VueBaseDialog'
export default {
  name: 'PreviewPdf',
  components: {
    VueBaseDialog,
  },
  props: ['dialogConfig'],
  data () {
    return {

    }
  },
  mounted () {
    this.$nextTick(() => {
      const audio = this.$refs.audio;
      if (audio) {
        audio.addEventListener("play", this.handlePlay);
        audio.addEventListener("pause", this.handlePause);
      }
    });
  },
  beforeDestroy () {
    const audio = this.$refs.audio;
    if (audio) {

      audio.removeEventListener("play", this.handlePlay);
      audio.removeEventListener("pause", this.handlePause);
    }
  },
  methods: {
    handlePlay () {
      document.querySelector(".adorn-label").style.animationPlayState = "running";
      document.querySelector(".adorn-line-2").style.animationPlayState = "running";
    },
    handlePause () {
      document.querySelector(".adorn-label").style.animationPlayState = "paused";
      document.querySelector(".adorn-line-2").style.animationPlayState = "paused";
    }

  }
}
</script>

<style lang="less">
.img-view {
    text-align: center;
}
#imgPreview {
    max-width: 90vw;
    max-height: 90vh;
    height: auto;
}
.audio-view {
    display: block;
    margin: 30px auto;
}
.audio-adorn {
    width: 640px;
    height: 360px;
    background: #80dec9;
    position: relative;
    .adorn-label {
        width: 240px;
        height: 240px;
        background: url('../assets/imgs/common/audio.png') no-repeat
            center/cover;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: rotate(0deg) translate(-50%, -50%);
        animation: rotate1 6s linear infinite;
        animation-play-state: paused;
    }
    .adorn-line-1 {
        width: 60px;
        height: 74px;
        background: url('../assets/imgs/common/audio-line-1.png') no-repeat
            center/cover;
        position: absolute;
        top: 36px;
        right: 90px;
    }
    .adorn-line-2 {
        width: 60px;
        height: 191px;
        background: url('../assets/imgs/common/audio-line-2.png') no-repeat
            center/cover;
        position: absolute;
        top: 109px;
        right: 90px;
        transform: rotate3d(0, 0, 0, 0deg) translate3d(0, 0, 0);
        animation: rotate 6s linear infinite;
        animation-play-state: paused;
    }
}
@keyframes rotate {
    0% {
        transform: rotate3d(0, 0, 0, 0deg) translate3d(0, 0, 0);
    }
    50% {
        transform: rotate3d(0, 0, 1, 36deg) translate3d(-57px, 14px, 0px);
    }

    100% {
        transform: rotate3d(0, 0, 0, 0deg) translate3d(0, 0, 0);
    }
}

@keyframes rotate1 {
    0% {
        transform: translate(-50%, -50%) rotate(0deg);
    }
    100% {
        transform: translate(-50%, -50%) rotate(360deg);
    }
}
</style>